var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#8100D9",
    fillOpacity: 0.94
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.105 47.456c-7.258 0-10.488-6.574-10.488-13.11s3.23-13.072 10.488-13.072c7.22 0 10.488 6.536 10.488 13.072s-3.268 13.11-10.488 13.11zm0-4.788c3.61 0 4.978-3.648 4.978-8.322 0-4.674-1.368-8.284-4.978-8.284-3.648 0-5.016 3.61-5.016 8.284 0 4.674 1.368 8.322 5.016 8.322zM55.752 47H36.676v-4.218C47.05 35.106 50.09 32.484 50.09 29.368c0-2.204-2.014-3.306-4.104-3.306-2.888 0-5.092 1.14-6.802 2.926l-3.078-3.572c2.47-2.85 6.232-4.142 9.766-4.142 5.396 0 9.69 3.04 9.69 8.094 0 4.332-3.572 8.094-10.146 12.882h10.336V47z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber2);
export default __webpack_public_path__ + "static/media/Number2.c3183ef84b48aeceba7498044bd1f7b4.svg";
export { ForwardRef as ReactComponent };